const RequiredStar = () => {
  return <span className="text-danger">*</span>;
};

export default RequiredStar;
